import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

/** อ่านจาก assets/version.json ที่สร้างตอน build (scripts/write-version.js) ไม่เรียก /actuator/info แล้ว */
export type Version = {
  version: string,
  datetime: string
}

@Injectable({providedIn: "root"})
export class VersionService {
  private http = inject(HttpClient)

  getVersion(): Observable<Version> {
    // เป็น static asset ของหน้าบ้านเอง (relative ไม่ผ่าน serverUrl) กัน cache ด้วย timestamp
    return this.http.get<Version>(`assets/version.json?t=${Date.now()}`)
  }
}
